import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculators.component.scss';
var WpbbsaCalculators = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculators, _super);
    function WpbbsaCalculators(element) {
        return _super.call(this, element) || this;
    }
    WpbbsaCalculators.prototype.init = function () { };
    WpbbsaCalculators.prototype.bindEvents = function () { };
    return WpbbsaCalculators;
}(Base));
export { WpbbsaCalculators };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculators/wpbbsa-calculators.component.ts
// module id = 1009
// module chunks = 0